import WixSDK from 'shared/utils/wix-sdk';


export const getCompId = () => WixSDK.Utils.getOrigCompId() || WixSDK.Utils.getCompId();



// WEBPACK FOOTER //
// ./src/shared/utils/comp-id.js